import Vue from 'vue'
import axios from 'axios'
import headers from './headers'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000,
})

instance.interceptors.request.use((config) => {
  Vue.set(config, 'headers', headers())

  return config
})

export default instance
